
import "./App.css";
import { Routes } from "./Routes";
import { ThemeProvider, createTheme } from "@mui/material";
import ScrollToTop from "./ScrollToTop";
import { Analytics } from "@vercel/analytics/react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const theme = createTheme({
  palette: {
    primary: {
      main: "#BC172F",
    },
  },
  typography: {
    fontFamily: "outfit",
    fontWeight: 300,
    fontSize: "14px",
    button: {
      textTransform: "initial",
      fontWeight: 400,
    },
    caption: {
      fontSize: "11px",
    },
  },
});
function App() {
  const queryClient = new QueryClient();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <Routes />
          <Analytics />
          <ScrollToTop />
        </ThemeProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
